export default __webpack_public_path__ + "static/media/bidayuh_icon.a5a698d1.png";